<template>
  <div
    class="d-flex jc-center ai-center h-100 p-relative min-height overflow-y-overlay"
  >
    <div class="design-main d-flex">
      <div class="w-100 px-16 py-5">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  methods: {
    ...mapMutations("header", ["setHeaderAttr"]),
    ...mapMutations("contact", ["setShow"])
  },
  created() {
    this.setShow(false);
    this.setHeaderAttr({
      background: "default",
      fixedTop: false,
      higher: false,
      hideNav: true
    });
    this.$vuetify.theme.dark = true;
  }
};
</script>

<style lang="sass" scoped>
.min-height
  min-height: 40rem
.design-main
  position: absolute
  width: 95%
  min-height: 30rem
  height: 90%
  border-radius: 1rem
  background-image: url("/assets/bg/bg_application environment.png")
</style>
